(function setupMetaPixelTracking() {
  "use strict";

  if (window.__onoureMetaPixelLoaded) return;
  window.__onoureMetaPixelLoaded = true;

  var SIX_PART_SERIES_PIXEL_ID = "1044969985114703";
  var MAIN_PIXEL_ID = "1949738232414443";

  /*
   * Which Klaviyo form is allowed to fire Lead.
   *
   * This site has more than one Klaviyo form (the landing-page embed AND the
   * site-wide pop-up), so this MUST be scoped — otherwise a pop-up signup would
   * fire a Lead attributed to the Six-Part Series.
   *
   * "VSxc7t" is taken from the embed container class (.klaviyo-form-VSxc7t).
   * VERIFY IT ONCE on staging: submit the form and check the console. If the ID
   * is wrong, the warning logged below will print the real one — paste that here.
   * Set to null only if you want ANY Klaviyo form on the page to fire Lead.
   */
  var TARGET_FORM_ID = "VSxc7t";

  /* Lead event parameters — as specified by the client. */
  var LEAD_PARAMS = {
    value: 9.68,
    currency: "AUD",
    content_name: "Onoure 6-Part Series"
  };

  /*
   * Redirect safety net.
   *
   * The Klaviyo form is configured to redirect to the thank-you page on success.
   * That redirect can begin before the browser has finished sending the Lead
   * request, which silently loses the conversion on slower connections.
   *
   * With this enabled we stash the Lead in sessionStorage at submit time and
   * re-fire it on the next page load using the SAME eventID. Meta deduplicates
   * events that share an event name + eventID, so this cannot double-count
   * WHEN Meta's client + server events are correctly deduplicated on the
   * SAME pixel. In practice Events Manager was still counting a second Lead
   * per signup here, so per the client this is now disabled — the submit-time
   * fire (below, on the klaviyoForms event) is the ONLY place Lead fires.
   *
   * Set to false to fire strictly once, at submit time only.
   */
  var ENABLE_REDIRECT_FALLBACK = false;
  var PENDING_LEAD_KEY = "onoure_pending_lead";
  var PENDING_LEAD_MAX_AGE_MS = 10 * 60 * 1000; // 10 minutes

  /* ---------------------------------------------------------------------
   * Meta base pixel code
   * Safe to include even if Shopify's native app already defines window.fbq —
   * the standard snippet no-ops via `if (f.fbq) return`.
   * ------------------------------------------------------------------- */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  var fbq = window.fbq;

  fbq("init", SIX_PART_SERIES_PIXEL_ID);

  /*
   * The main pixel must also be known to THIS fbq instance, otherwise
   * fbq("trackSingle", MAIN_PIXEL_ID, "Lead") is silently dropped.
   *
   * Shopify's Facebook & Instagram channel now runs as a sandboxed Web Pixel,
   * which means it does not touch window.fbq on the page at all — so without
   * this line the main pixel's Lead never leaves the browser.
   *
   * "init" on its own NEVER sends a PageView, so this cannot double-count the
   * main pixel's PageView. If Shopify already inited this ID on this instance,
   * the call is a harmless no-op.
   */
  fbq("init", MAIN_PIXEL_ID);

  /* PageView for the Six-Part Series pixel only. */
  fbq("trackSingle", SIX_PART_SERIES_PIXEL_ID, "PageView");

  /* --- helpers ------------------------------------------------------- */

  function generateEventId() {
    return "onoure-lead-" + Date.now() + "-" + Math.random().toString(36).slice(2, 10);
  }

  function fireLead(email, eventId) {
    if (email) {
      // Meta hashes this client-side before it is sent.
      var normalisedEmail = String(email).trim().toLowerCase();
      fbq("set", "userData", { em: normalisedEmail });
      fbq("set", "userData", SIX_PART_SERIES_PIXEL_ID, { em: normalisedEmail });
      fbq("set", "userData", MAIN_PIXEL_ID, { em: normalisedEmail });
    }
    fbq("trackSingle", SIX_PART_SERIES_PIXEL_ID, "Lead", LEAD_PARAMS, { eventID: eventId });
    fbq("trackSingle", MAIN_PIXEL_ID, "Lead", LEAD_PARAMS, { eventID: eventId });
  }

  function readPendingLead() {
    try {
      var raw = window.sessionStorage.getItem(PENDING_LEAD_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.eventId) return null;
      if (Date.now() - (parsed.ts || 0) > PENDING_LEAD_MAX_AGE_MS) return null;
      return parsed;
    } catch (err) {
      return null;
    }
  }

  function writePendingLead(record) {
    try {
      window.sessionStorage.setItem(PENDING_LEAD_KEY, JSON.stringify(record));
    } catch (err) {
      /* private mode / storage disabled — the submit-time fire still stands */
    }
  }

  function clearPendingLead() {
    try {
      window.sessionStorage.removeItem(PENDING_LEAD_KEY);
    } catch (err) {
      /* no-op */
    }
  }

  /* --- redirect safety net: re-fire on the next page load ------------- */

  if (ENABLE_REDIRECT_FALLBACK) {
    var pending = readPendingLead();
    if (pending) {
      clearPendingLead();
      fireLead(pending.email, pending.eventId);
    }
  }

  /* --- Lead, triggered by Klaviyo's own form event -------------------- */

  window.addEventListener("klaviyoForms", function (event) {
    var detail = event.detail || {};
    if (detail.type !== "submit") return;

    if (TARGET_FORM_ID && detail.formId !== TARGET_FORM_ID) {
      console.warn(
        "[Onoure] Klaviyo submit ignored for Meta Lead — formId was '" +
          detail.formId +
          "' but TARGET_FORM_ID is set to '" +
          TARGET_FORM_ID +
          "'. If this WAS the Six-Part Series form, update TARGET_FORM_ID in meta-pixel-tracking.js."
      );
      return;
    }

    var metaData = detail.metaData || {};
    var email = metaData.email || metaData["$email"] || "";

    if (!email) {
      // Still fire the conversion — we just lose Advanced Matching on it.
      console.warn("[Onoure] No email found on Klaviyo submit payload:", metaData);
    }

    var eventId = generateEventId();

    if (ENABLE_REDIRECT_FALLBACK) {
      writePendingLead({ eventId: eventId, email: email, ts: Date.now() });
    }

    fireLead(email, eventId);
  });
})();